<template>
  <div style="min-height: 80vh" class="mx-5">
    <div
      style="position: sticky; top: 4vh; z-index: 1000"
      :class="{
        'bg-light': !isDarkMode,
        'bg-dark text-light ': isDarkMode
      }"
    >
      <h1
        :class="{
          'bg-light text-center page-title ': !isDarkMode,
          'bg-dark text-light text-center page-title ': isDarkMode
        }"
        class=""
        >{{ title }}</h1
      >
      <b-row
        style="justify-content: space-between"
        :class="{
          'bg-light mx-2  py-3': !isDarkMode,
          ' mx-2  py-3 bg-dark text-light': isDarkMode
        }"
        ><b-col xl="5">
          <b-row>
            <b-col>
              <b-form-select
                aria-placeholder="select"
                v-model="primarySelectedFilter"
                :options="primaryFilterOptions"
                :class="{
                  'box-shadow2 mb-2': !isDarkMode,
                  'box-shadow2 bg-dark text-light mb-2': isDarkMode
                }"
              ></b-form-select>
            </b-col>
            <b-col>
              <b-form-select
                v-model="secondarySelectedFilter"
                :options="secondaryFilterOptions"
                :class="{
                  'box-shadow2  mb-2': !isDarkMode,
                  'box-shadow2 bg-dark text-light  mb-2': isDarkMode
                }"
              ></b-form-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="6">
          <b-row>
            <b-col>
              <b-form data-v-step="1">
                <b-input-group class="box-shadow2 mb-2">
                  <b-input-group-append>
                    <b-form-datepicker
                      sm
                      button-only
                      id="start-datepicker"
                      placeholder="Start Date"
                      :min="minDate"
                      :max="maxDate"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      v-model="startDateValue"
                    >
                    </b-form-datepicker>
                  </b-input-group-append>
                  <b-form-input
                    id="example-input"
                    v-model="startDateValue"
                    type="text"
                    placeholder="Start Date"
                    autocomplete="off"
                    :class="{
                      '': !isDarkMode,
                      'bg-dark text-light': isDarkMode
                    }"
                    disabled
                  ></b-form-input>
                </b-input-group> </b-form
            ></b-col>
            <b-col>
              <b-form>
                <b-input-group class="box-shadow2 mb-2">
                  <b-input-group-append>
                    <b-form-datepicker
                      button-only
                      id="end-datepicker"
                      placeholder="End Date"
                      :min="minDate"
                      :max="maxDate"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      v-model="endDateValue"
                    ></b-form-datepicker>
                  </b-input-group-append>
                  <b-form-input
                    id="example-input"
                    v-model="endDateValue"
                    type="text"
                    placeholder="End Date"
                    autocomplete="off"
                    :class="{
                      '': !isDarkMode,
                      'bg-dark text-light ': isDarkMode
                    }"
                    disabled
                  ></b-form-input>
                </b-input-group> </b-form
            ></b-col>
            <b-col>
              <b-form>
                <b-button
                  data-v-step="2"
                  :class="{
                    'box-shadow2 btn btn-success  mb-2': !isDarkMode,
                    'btn btn-primary text-light  mb-2': isDarkMode
                  }"
                  @click="showChart"
                  ><font-awesome-icon class="mr-1" :icon="['fas', 'arrow-alt-circle-right']"
                /></b-button> </b-form
            ></b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <!-- <b-overlay :show="loading" :variant="!isDarkMode ? 'light' : 'dark'" rounded="sm" no-wrap>
      <template #overlay>
        <div class="d-flex justify-content-center align-items-center h-100">
          <b-spinner :variant="!isDarkMode ? 'dark' : 'light'" label="Loading"></b-spinner>
        </div>
      </template>
</b-overlay> -->
    <b-col>
      <VideoSection />
    </b-col>
    <b-row
      :class="{
        ' mx-2': !isDarkMode,
        'bg-dark text-light mx-2': isDarkMode
      }"
    >
      <b-col>
        <DashboardSection
          :loading="loading || storeLoading"
          :chartVisible="chartVisible"
          :dashboardDetails="completionStatus"
        />
      </b-col>
    </b-row>
    <!-- <b-row -->
    <!--   :class="{ -->
    <!--     ' mt-4 mx-2': !isDarkMode, -->
    <!--     'mt-4 bg-dark text-light mx-2': isDarkMode -->
    <!--   }" -->
    <!-- > -->
    <!--   <b-col> -->
    <!--     <DashboardSection -->
    <!--       :loading="this.reportAILoading" -->
    <!--       :chartVisible="chartVisible" -->
    <!--       :dashboardDetails="aiReportStatus" -->
    <!--       :checked="imageType === 'correct' ? true : false" -->
    <!--       :switchRequired="true" -->
    <!--       :showAdd="this.isAdmin || this.isSubAdmin" -->
    <!--       :showRoute="this.isAdmin || this.isSubAdmin" -->
    <!--       :aSMReportLoading="this.aSMReportLoading" -->
    <!--       addText="Download Report" -->
    <!--       @update-image-type="imageType = $event" -->
    <!--       @add="downloadASMReport" -->
    <!--     /> -->
    <!--   </b-col> -->
    <!-- </b-row> -->
    <b-row
      :class="{
        'mt-4 mx-2': !isDarkMode,
        'mt-4 bg-dark text-light mx-2': isDarkMode
      }"
    >
      <b-col>
        <DashboardSection
          :loading="loading || storeLoading"
          :chartVisible="chartVisible"
          :dashboardDetails="completionScore"
        />
      </b-col>
    </b-row>
    <b-row
      :class="{
        ' mt-4 mx-2': !isDarkMode,
        'mt-4 bg-dark text-light mx-2': isDarkMode
      }"
    >
      <b-col class="m-1 box-shadow2 p-4 dashHead" style="border-radius: 20px">
        <b-overlay :show="reportLoading" :variant="!isDarkMode ? 'light' : 'dark'" rounded="sm" no-wrap>
          <template #overlay>
            <div class="d-flex justify-content-center align-items-center h-100">
              <b-spinner :variant="!isDarkMode ? 'dark' : 'light'" label="Loading"></b-spinner>
            </div>
          </template>
        </b-overlay>
        <h3>POP Analatics </h3>
        <div class="row">
          <div class="col-md-6">
            <h5 class="mb-2">Deactivated Promo : {{ popReportData.deactiveCount }}</h5>
            <h5 class="mb-2">Expired Promo: {{ popReportData.expiredCount }}</h5>
            <h5 class="mb-2">New Promo : {{ popReportData.newPromoCount }}</h5>
            <h5 class="mb-2">Total Printed : {{ popReportData.isPrintedNewPromo }}</h5>
            <h5 class="mb-2">Total Available: {{ popReportData.stockAvailable }}</h5>
          </div>
          <div class="col-md-6">
            <h5 class="mb-2">
              Avg. Deactivated Promo:
              {{ popReportData.noOfStores ? (popReportData.deactiveCount / popReportData.noOfStores).toFixed(1) : 0 }}
            </h5>
            <h5 class="mb-2">
              Avg. Expired Promo:
              {{ popReportData.noOfStores ? (popReportData.expiredCount / popReportData.noOfStores).toFixed(1) : 0 }}
            </h5>
            <h5 class="mb-2">
              Avg. New Promo :
              {{ popReportData.noOfStores ? (popReportData.newPromoCount / popReportData.noOfStores).toFixed(1) : 0 }}
            </h5>
            <h5 class="mb-2">
              Avg. Printed :
              {{
                popReportData.noOfStores ? (popReportData.isPrintedNewPromo / popReportData.noOfStores).toFixed(1) : 0
              }}
            </h5>
            <h5 class="mb-2">
              Avg. Available:
              {{ popReportData.noOfStores ? (popReportData.stockAvailable / popReportData.noOfStores).toFixed(1) : 0 }}
            </h5>
          </div>
        </div>
      </b-col>
      <!--  <b-col class="m-1 box-shadow2 p-4 dashHead" style="border-radius: 20px">
        <b-overlay :show="ticketLoading" :variant="!isDarkMode ? 'light' : 'dark'" rounded="sm" no-wrap>
          <template #overlay>
            <div class="d-flex justify-content-center align-items-center h-100">
              <b-spinner :variant="!isDarkMode ? 'dark' : 'light'" label="Loading"></b-spinner>
            </div>
          </template>
        </b-overlay>
        <h3>Ticket Analatics </h3>
        <div class="row">
          <div class="col-md-6">
            <h5>Total Tickets: {{ ticket.totalTickets }}</h5>
            <h5>Pending Tickets: {{ ticket.pendingTickets }}</h5>
          </div>
          <div class="col-md-6">
            <h5>In Progress Tickets: {{ ticket.inProgressTickets }}</h5>
            <h5>Resolved Tickets: {{ ticket.resolvedTickets }}</h5>
          </div>
        </div>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import router from '@/router';
import { mapState, mapActions, mapGetters } from 'vuex';
import DashboardSection from '../../components/DashboardSection.vue';
import VideoSection from './VideoSection.vue';
import { LoggedInUser } from '../../helper/dashboard.js';
import _ from 'lodash';

export default {
  name: 'Dashboard2',
  metaInfo() {
    return {
      title: 'Dashboard',
      meta: [
        {
          name: 'description',
          content: `See Charts`
        }
      ]
    };
  },
  components: { DashboardSection, VideoSection },
  data() {
    return {
      title: 'Dashboard',
      secondaryFilterOptions: [{ text: 'select', value: 'select' }],
      secondarySelectedFilter: 'select',
      asmName: '',
      primarySelectedFilter: 'select',
      startDateValue: moment().format('YYYY-MM-DD'),
      endDateValue: moment().format('YYYY-MM-DD'),
      minDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD'),
      chartVisible: true,
      completionStatus: {
        heading: 'Checklist Completion Status',
        overallCompletion: 0,
        regionDetails: [],
        checklists: []
      },
      imageType: 'correct',
      aiReportStatus: {
        heading: `AI correct status`,
        overallCompletion: 0,
        regionDetails: [],
        checklists: []
      },
      completionScore: {
        heading: 'Checklist Completion Score',
        overallCompletion: 0,
        regionDetails: [],
        checklists: []
      },
      popReportData: {
        deactiveCount: 0,
        expiredCount: 0,
        isPrintedNewPromo: 0,
        newPromoCount: 0,
        notPrintedNewPromo: 0,
        stockAvailable: 0,
        total: 0,
        noOfStores: 1
      },
      ticket: {
        totalTickets: 0,
        pendingTickets: 0,
        inProgressTickets: 0,
        resolvedTickets: 0
      }
    };
  },
  created() {
    if (
      this.user.roles.some(
        role => role.name === 'ADMIN' || role.name === 'SUB_ADMIN' || role.name === 'CEO' || role.name === 'HO_VIEWER'
      )
    ) {
      this.primarySelectedFilter = 'india';
    } else {
      this.primarySelectedFilter = 'select';
    }
  },
  async mounted() {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
      this.startDateValue = this.$route.query.startdate;
    }
    if (this.ifPettyCashTeam) {
      router.push('/petty-cash');
    } else {
      await this.getStoreByUser();
      this.listStore({ router });
      this.asmListAction({ router });
      this.listRegion({ router, query: { type: 'region' } });
      this.list({ type: 'user', query: this.$route.query });
      const abc = LoggedInUser(this.user, this.store);
      if (abc.userType !== 'RSM' && abc.userType !== 'ASM' && abc.userType !== 'SM') {
        if (_.isEmpty(this.$route.query)) {
          this.mobileList({
            router,
            query: {
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
          this.aiReport({
            router,
            query: {
              startdate: moment(this.startDateValue).subtract(1, 'days').format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).subtract(1, 'days').format('YYYY-MM-DD')
            }
          });
          this.ticketAnalatics({
            router,
            query: {
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
          this.report({
            router,
            query: {
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
        } else {
          this.mobileList({
            query: {
              ...this.$route.query,
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
          this.aiReport({
            router,
            query: {
              ...this.$route.query,
              startdate: moment(this.startDateValue).subtract(1, 'days').format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).subtract(1, 'days').format('YYYY-MM-DD')
            }
          });
          this.report({
            query: {
              ...this.$route.query,
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
          this.ticketAnalatics({
            router,
            query: {
              ...this.$route.query,
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
        }
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.mobileList({ query: to.query });
    this.report({ query: to.query });
    this.aiReport({ query: to.query });
    this.ticketAnalatics({ query: to.query });
    next();
  },
  methods: {
    ...mapActions('asmList', ['asmListAction']),
    ...mapActions('dashboard', ['mobileList', 'ticketAnalatics', 'aiReport', 'aiASMReport']),
    ...mapActions('store', ['listStore', 'listRegion']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    ...mapActions('user', ['list']),
    ...mapActions('popPrint', ['report']),
    downloadASMReport() {
      //      router.push('/asmDashboard');
      this.aiASMReport({
        router,
        query: {
          startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
          enddate: moment(this.endDateValue).format('YYYY-MM-DD')
        }
      });
    },
    aiCalculations(newValue, imageType) {
      const updatedStatusRegionDetails = (newValue.all ?? [])
        .map((regionObj, index) => {
          const regionName = Object.keys(regionObj)[0];
          const regionData = regionObj[regionName];

          const count = regionData?.[imageType] ?? 0;
          const completion = regionData.total ? Math.round((count / regionData.total) * 100) : 0;

          return {
            id: index + 1,
            name: regionName,
            correct: regionData.correct,
            incorrect: regionData.incorrect,
            total: regionData.total,
            completion
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name));

      // 2. Overall Completion
      const count = newValue?.[imageType] ?? 0;
      const overallCompletion = newValue.total ? Math.round((count / newValue.total) * 100) : 0;

      // 3. Date-wise Stats
      const flattenedByDate = (newValue.byDate ?? []).reduce((acc, item) => {
        const key = Object.keys(item)[0];
        acc[parseInt(key, 10)] = item[key];
        return acc;
      }, {});

      const statusByDate = Array.from({ length: 30 }, (_, i) => {
        const dayNumber = i + 1;
        const data = flattenedByDate[dayNumber];

        const count = data?.[imageType] ?? 0;
        const completion = data?.total ? Math.round((count / data.total) * 100) : 0;

        return {
          id: dayNumber,
          date: dayNumber,
          correct: data?.correct ?? 0,
          incorrect: data?.incorrect ?? 0,
          total: data?.total ?? 0,
          completion
        };
      });

      // 4. Checklist Breakdown
      const checklists = Object.entries(newValue.checklistsByRegion ?? {}).map(([checklistName, regionsData]) => {
        let totalCount = 0;
        let totalTotal = 0;

        const regions = Object.entries(regionsData).map(([regionName, data]) => {
          const { correct = 0, incorrect = 0, total = 0 } = data;
          const count = imageType === 'correct' ? correct : incorrect;

          totalCount += count;
          totalTotal += total;

          return {
            region: regionName,
            correct,
            incorrect,
            total,
            compliance: total ? Math.round((count / total) * 100) : 0
          };
        });

        return {
          appendText: 'status',
          checklist: checklistName,
          compliance: totalTotal ? Math.round((totalCount / totalTotal) * 100) : 0,
          regions
        };
      });

      // 5. Combine all results
      return {
        score: statusByDate,
        overallCompletion,
        checklists,
        heading: `AI Validation ${imageType === 'correct' ? 'Pass' : 'Fail'} %`,
        regionDetails: updatedStatusRegionDetails
      };
    },
    showChart() {
      const startDate = moment(this.startDateValue);
      const endDate = moment(this.endDateValue);
      const difference = endDate.diff(startDate, 'days');
      if (difference >= 0 && difference <= 31) {
        const query = { ...this.$route.query };
        this.$router.push({
          query: {
            ...query,
            startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
            enddate: moment(this.endDateValue).format('YYYY-MM-DD')
          }
        });
      } else {
        Vue.swal({
          title: 'Proceed Validation',
          text: `Days limit upto 30`,
          type: 'error',
          background: this.isDarkMode ? '#464d54' : '#ffffff',
          customClass: {
            title: this.isDarkMode ? 'text-light' : 'text-dark',
            content: this.isDarkMode ? 'text-light' : 'text-dark'
          }
        });
      }
    }
  },
  computed: {
    ...mapState('popPrint', ['popReport', 'reportLoading']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store', 'storeLoading']),
    ...mapState('asmList', ['asmList']),
    ...mapState('dashboard', [
      'loading',
      'reportAILoading',
      'dashboardData',
      'ticketData',
      'ticketLoading',
      'dashboardAiReport',
      'dashboardASMAiReport',
      'aSMReportLoading'
    ]),
    ...mapState('store', ['storeList', 'regionList']),
    ...mapState('user', ['users']),
    ...mapGetters('pettyCash', ['ifPettyCashTeam']),
    isAdmin() {
      return this.user.roles.some(role => role.name === 'ADMIN');
    },
    isSubAdmin() {
      return this.user.roles.some(role => role.name === 'SUB_ADMIN');
    },
    isCEO() {
      return this.user.roles.some(role => role.name === 'CEO' || role.name === 'HO_VIEWER');
    },
    isRSM() {
      return this.user.roles.some(role => role.name === 'REGIONAL_SALES_MANAGER');
    },
    isASM() {
      return this.user.roles.some(role => role.name === 'AREA_SALES_MANAGER');
    },
    isSSM() {
      return this.user.roles.some(role => role.name === 'STORE_SALES_MANAGER');
    },
    loginnedUserRegions() {
      return this.users.filter(i => i.mobile === this.user.mobile).map(item => item.regions);
    },
    totalStoreList() {
      return this.storeList
        .map(item => ({ text: `${item.storeName}-${item.storeid}`, value: item.storeid }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    loginnedUserStores() {
      return this.store
        .map(item => ({ text: `${item.storeName}-${item.storeid}`, value: item.storeid }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    renderedASMList() {
      return this.asmList
        .map(item => ({ text: item.value, value: item.key }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    primaryFilterOptions() {
      if (this.isRSM) {
        return [
          { text: 'select', value: 'select' },
          { text: 'ASM ', value: 'asm' },
          { text: 'Store', value: 'store' }
        ];
      }
      if (this.isASM || this.isSSM) {
        return [
          { text: 'select', value: 'select' },
          { text: 'Store', value: 'store' }
        ];
      }
      if (this.isAdmin || this.isSubAdmin || this.isCEO) {
        return [
          { text: 'select', value: 'select' },
          { text: 'India', value: 'india' },
          { text: 'Region', value: 'region' },
          { text: 'ASM', value: 'asm' },
          { text: 'Store', value: 'store' }
        ];
      }
      return [
        { text: 'select', value: 'select' },
        { text: 'Store', value: 'store' }
      ];
    }
  },
  watch: {
    dashboardASMAiReport(newValue) {
      if (!Array.isArray(newValue) || newValue.length === 0) return;

      const groupedByASM = {};

      for (const item of newValue) {
        const asm = item.asmName?.trim() || 'Unknown';
        const checklist = item.checklist?.trim() || 'Unknown';
        const storeName = item.storeName?.trim() || 'Unknown Store';
        const storeId = item.storeId?.trim() || 'Unknown ID';
        const isCorrect = item.remarks?.trim().toLowerCase() === 'correct';

        if (!groupedByASM[asm]) {
          groupedByASM[asm] = { checklists: {}, stores: {} };
        }

        // Checklist Grouping
        if (!groupedByASM[asm].checklists[checklist]) {
          groupedByASM[asm].checklists[checklist] = { Correct: 0, Incorrect: 0 };
        }
        groupedByASM[asm].checklists[checklist][isCorrect ? 'Correct' : 'Incorrect']++;

        // Store Grouping
        const storeKey = `${storeName}__${storeId}`;
        if (!groupedByASM[asm].stores[storeKey]) {
          groupedByASM[asm].stores[storeKey] = { storeName, storeId, Correct: 0, Incorrect: 0 };
        }
        groupedByASM[asm].stores[storeKey][isCorrect ? 'Correct' : 'Incorrect']++;
      }

      let csv = '';

      // ============================
      // ASM-wise Summary Section
      // ============================
      csv += `ASM Name,Checklist Name,Correct,Incorrect,Total Result\n`;

      for (const [asm, data] of Object.entries(groupedByASM)) {
        let asmChecklistCorrect = 0;
        let asmChecklistIncorrect = 0;

        const checklistEntries = Object.entries(data.checklists);

        checklistEntries.forEach(([checklist, counts], index) => {
          const correct = counts.Correct || 0;
          const incorrect = counts.Incorrect || 0;
          const total = correct + incorrect;

          asmChecklistCorrect += correct;
          asmChecklistIncorrect += incorrect;

          const asmDisplay = index === 0 ? asm : '';
          csv += `${asmDisplay},${checklist},${correct},${incorrect},${total}\n`;
        });

        // Total row
        csv += `,,${asmChecklistCorrect},${asmChecklistIncorrect},${asmChecklistCorrect + asmChecklistIncorrect}\n\n`;

        // ============================
        // ASM-specific Store Summary
        // ============================
        csv += `Store Name,Store ID,Correct,Incorrect,Total\n`;
        let asmStoreCorrect = 0;
        let asmStoreIncorrect = 0;

        for (const store of Object.values(data.stores)) {
          const { storeName, storeId, Correct, Incorrect } = store;
          const total = Correct + Incorrect;
          asmStoreCorrect += Correct;
          asmStoreIncorrect += Incorrect;
          csv += `${storeName},${storeId},${Correct},${Incorrect},${total}\n`;
        }

        // Store total
        csv += `ASM Total Stores,,${asmStoreCorrect},${asmStoreIncorrect},${asmStoreCorrect + asmStoreIncorrect}\n\n\n`;
      }

      // Trigger CSV Download
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'ASM_Ai_Report.csv';
      anchor.click();
    },
    ticketData(newValue) {
      if (newValue.totalComplaints > 0) {
        this.ticket.totalTickets = newValue.totalComplaints;
        this.ticket.pendingTickets = newValue.statusCount.PENDING;
        this.ticket.inProgressTickets = newValue.statusCount['IN PROGRESS'];
        this.ticket.resolvedTickets = newValue.resolvedCount;
      }
    },
    popReport(newValue) {
      if (newValue) {
        this.popReportData.deactiveCount = newValue.deactiveCount;
        this.popReportData.expiredCount = newValue.expiredCount;
        this.popReportData.isPrintedNewPromo = newValue.isPrintedNewPromo;
        this.popReportData.newPromoCount = newValue.newPromoCount;
        this.popReportData.stockAvailable = newValue.stockAvailable;
        this.popReportData.total = newValue.total;
        this.popReportData.noOfStores = newValue.noOfStores;
      }
    },
    store(newValue) {
      if (newValue.length > 0) {
        const abc = LoggedInUser(this.user, this.store);
        if (abc.userType === 'ASM' || abc.userType === 'SM' || abc.userType === 'RSM') {
          this.mobileList({
            router,
            query: {
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD'),
              ...(abc.userType === 'ASM' ? { asm: this.user.id } : {}),
              ...(abc.userType === 'RSM' ? { region: newValue[0]?.region } : {}),
              ...(abc.userType === 'SM' ? { storeid: abc.selectedSubGeographyType.value } : {})
            }
          });
          this.aiReport({
            router,
            query: {
              startdate: moment(this.startDateValue).subtract(1, 'days').format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).subtract(1, 'days').format('YYYY-MM-DD'),
              ...(abc.userType === 'ASM' ? { asm: this.user.id } : {}),
              ...(abc.userType === 'RSM' ? { region: newValue[0]?.region } : {}),
              ...(abc.userType === 'SM' ? { storeid: abc.selectedSubGeographyType.value } : {})
            }
          });
          this.report({
            router,
            query: {
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD'),
              ...(abc.userType === 'ASM' ? { asmName: this.user.name } : {}),
              ...(abc.userType === 'RSM' ? { region: newValue[0]?.region } : {}),
              ...(abc.userType === 'SM' ? { store: abc.selectedSubGeographyType.value } : {})
            }
          });
        }
        if (abc.userType === 'ASM' || abc.userType === 'SM') {
          this.chartVisible = false;
        }
      }
    },
    primarySelectedFilter(newValue) {
      if (newValue) {
        if (newValue === 'region') {
          this.secondaryFilterOptions = [...this.regionList.sort((a, b) => a.text.localeCompare(b.text))];
          //          this.secondarySelectedFilter = this.regionList[0].value;
        } else if (newValue === 'store') {
          if (this.isAdmin) {
            this.secondaryFilterOptions = [...this.totalStoreList];
            //            this.secondarySelectedFilter = this.totalStoreList[0].value;
          } else {
            this.secondaryFilterOptions = [...this.loginnedUserStores];
            //            this.secondarySelectedFilter = this.loginnedUserStores[0].value;
          }
        } else if (newValue === 'asm') {
          this.secondaryFilterOptions = [...this.renderedASMList];
          //          this.secondarySelectedFilter = this.renderedASMList[0].value;
          //          this.asmName = this.renderedASMList[0].text;
        } else if (newValue === 'india') {
          this.secondarySelectedFilter = 'india';
          this.secondaryFilterOptions = [{ text: 'india', value: 'india' }];
          const query = { ...this.$route.query };
          delete query.region;
          delete query.storeid;
          delete query.asm;
          delete query.store;
          delete query.asmName;
          this.$router.push({ query });
          this.chartVisible = true;
        } else {
          this.secondarySelectedFilter = 'select';
          this.secondaryFilterOptions = [{ text: 'select', value: 'select' }];
          const query = { ...this.$route.query };
          delete query.region;
          delete query.storeid;
          delete query.store;
          delete query.asm;
          delete query.asmName;
          this.$router.push({ query });
          this.chartVisible = true;
        }
      }
    },
    secondarySelectedFilter(newValue) {
      if (newValue && newValue !== 'select') {
        if (this.primarySelectedFilter === 'region') {
          const query = { ...this.$route.query };
          delete query.asm;
          delete query.asmName;
          delete query.storeid;
          delete query.store;
          this.$router.push({
            query: {
              ...query,
              region: newValue,
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
          this.chartVisible = true;
        } else if (this.primarySelectedFilter === 'store') {
          const query = { ...this.$route.query };
          delete query.asm;
          delete query.asmName;
          delete query.region;
          this.$router.push({
            query: {
              ...query,
              storeid: newValue,
              store: newValue,
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
          this.chartVisible = false;
        } else if (this.primarySelectedFilter === 'asm' && newValue) {
          const query = { ...this.$route.query };
          delete query.region;
          delete query.storeid;
          delete query.store;
          const asmName = this.secondaryFilterOptions.filter(i => i.value === newValue)[0]?.text;
          this.$router.push({
            query: {
              ...query,
              asmName,
              asm: newValue,
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
          this.chartVisible = false;
        }
      } else {
        const query = { ...this.$route.query };
        delete query.asm;
        delete query.asmName;
        delete query.store;
        delete query.region;
        delete query.storeid;
        this.$router.push({ query });
      }
    },
    imageType(newValue) {
      const abc = this.aiCalculations(this.dashboardAiReport, newValue);
      this.aiReportStatus = {
        ...this.aiReportStatus,
        ...abc
      };
    },
    dashboardAiReport(newValue) {
      const imageType = this.imageType;

      // 1. Region-wise Summary
      const abc = this.aiCalculations(newValue, this.imageType);

      this.aiReportStatus = {
        ...this.aiReportStatus,
        ...abc
      };
    },
    dashboardData(newValue) {
      if (newValue) {
        const updatedStatusRegionDetails = Object.keys(newValue.complianceScoreByRegion ?? {})
          .map((item, index) => ({
            id: index + 1,
            name: item,
            completion: Math.round(newValue.complianceScoreByRegion[item] * 100)
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        const updatedScoreRegionDetails = Object.keys(newValue.checklistScoreByRegion ?? {})
          .map((item, index) => ({
            id: index + 1,
            name: item,
            completion: Math.round(newValue.checklistScoreByRegion[item] * 100)
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        const updatedScoreChecklist = newValue.actualChecklistScoreByRegion
          ? (newValue.actualChecklistScoreByRegion ?? [])
              .map(item => ({
                checklist: item.checklist ?? '',
                appendText: 'score',
                compliance: item.checklistScore !== null ? Math.round(item.checklistScore * 100) : 0,
                ...(this.primarySelectedFilter !== 'store' && !this.isSSM
                  ? {
                      regions:
                        this.isAdmin || this.isCEO || this.isSubAdmin
                          ? this.primarySelectedFilter === 'region' && typeof item.checklistScoreByASM === 'object'
                            ? Object.entries(item.checklistScoreByASM ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : this.primarySelectedFilter === 'asm' && typeof item.checklistScoreByStore === 'object'
                            ? Object.entries(item.checklistScoreByStore ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : typeof item.checklistScoreByRegion === 'object'
                            ? Object.entries(item.checklistScoreByRegion ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : []
                          : // eslint-disable-next-line no-nested-ternary
                          this.isRSM
                          ? this.primarySelectedFilter === 'asm' && typeof item.checklistScoreByStore === 'object'
                            ? Object.entries(item.checklistScoreByStore ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : Object.entries(item.checklistScoreByASM ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                          : this.isASM && typeof item.checklistScoreByStore === 'object'
                          ? Object.entries(item.checklistScoreByStore ?? {}).map(([region, value]) => ({
                              region,
                              compliance: value !== null ? Math.round(value * 100) : 0
                            }))
                          : []
                    }
                  : {})
              }))
              .sort((a, b) => a.checklist.localeCompare(b.checklist))
          : newValue.storeChecklistScoreData
          ? (newValue.storeChecklistScoreData ?? [])
              .map(item => ({
                checklist: item.checklist ?? '', // Fallback to empty string
                compliance: item.checklistCompliance !== null ? Math.round(item.checklistCompliance * 100) : 0
              }))
              .sort((a, b) => a.checklist.localeCompare(b.checklist))
          : null;

        const updatedStatusChecklist = newValue.actualChecklistData
          ? (newValue.actualChecklistData ?? [])
              .map(item => ({
                checklist: item.checklist ?? '', // Fallback to empty string
                appendText: 'status',
                compliance: item.checklistCompliance !== null ? Math.round(item.checklistCompliance * 100) : 0,
                ...(this.primarySelectedFilter !== 'store' || !this.isSSM
                  ? {
                      regions:
                        this.isAdmin || this.isCEO || this.isSubAdmin
                          ? this.primarySelectedFilter === 'region' && typeof item.checklistComplianceByASM === 'object'
                            ? Object.entries(item.checklistComplianceByASM ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : this.primarySelectedFilter === 'asm' &&
                              typeof item.checklistComplianceByStore === 'object'
                            ? Object.entries(item.checklistComplianceByStore ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : typeof item.checklistComplianceByRegion === 'object'
                            ? Object.entries(item.checklistComplianceByRegion ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : []
                          : this.isRSM
                          ? this.primarySelectedFilter === 'asm' && typeof item.checklistComplianceByStore === 'object'
                            ? Object.entries(item.checklistComplianceByStore ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                            : Object.entries(item.checklistComplianceByASM ?? {}).map(([region, value]) => ({
                                region,
                                compliance: value !== null ? Math.round(value * 100) : 0
                              }))
                          : this.isASM && typeof item.checklistComplianceByStore === 'object'
                          ? Object.entries(item.checklistComplianceByStore ?? {}).map(([region, value]) => ({
                              region,
                              compliance: value !== null ? Math.round(value * 100) : 0
                            }))
                          : []
                    }
                  : {})
              }))
              .sort((a, b) => a.checklist.localeCompare(b.checklist))
          : newValue.storeChecklistComplianceData
          ? (newValue.storeChecklistComplianceData ?? [])
              .map(item => ({
                checklist: item.checklist ?? '', // Fallback to empty string
                compliance: item.checklistCompliance !== null ? Math.round(item.checklistCompliance * 100) : 0
              }))
              .sort((a, b) => a.checklist.localeCompare(b.checklist))
          : null;

        const statusByDate = Array.from({ length: 30 }, (_, i) => {
          const dayNumber = i + 1;
          const matchingEntry = Object.entries(newValue.complianceScoreByDate ?? {}).find(([date]) => {
            return new Date(date).getDate() === dayNumber;
          });

          const value = matchingEntry ? matchingEntry[1] : null;

          return {
            id: i + 1,
            date: dayNumber,
            completion: value !== null ? Math.max(Math.round(value * 100), 10) : 0
          };
        });

        const scoreByDate = Array.from({ length: 30 }, (_, i) => {
          const dayNumber = i + 1;
          const matchingEntry = Object.entries(newValue.checklistScoreByDate ?? {}).find(([date]) => {
            return new Date(date).getDate() === dayNumber;
          });

          const value = matchingEntry ? matchingEntry[1] : null;
          return {
            id: i + 1,
            date: dayNumber,
            completion: value !== null ? Math.max(Math.round(value * 100), 10) : 0
          };
        });

        this.completionStatus = {
          ...this.completionStatus,
          overallCompletion: Math.floor(newValue.complianceScoreIndia * 100),
          regionDetails: updatedStatusRegionDetails,
          checklists: updatedStatusChecklist,
          score: statusByDate
        };
        this.completionScore = {
          ...this.completionScore,
          overallCompletion: Math.floor(newValue.checklistScoreIndia * 100),
          regionDetails: updatedScoreRegionDetails,
          checklists: updatedScoreChecklist,
          score: scoreByDate
        };
      }
    }
  }
};
</script>
